import type { ContentfulEnvironmentOverride, SitePreviewData } from '@libs/common-next';

import css from './environment-select.module.scss';

type Option = {
    value: ContentfulEnvironmentOverride | undefined;
    label: string;
};

type Props = {
    name: keyof SitePreviewData;
    value?: SitePreviewData[keyof SitePreviewData];
    options: readonly Option[];
    onChange: (key: keyof SitePreviewData, value: ContentfulEnvironmentOverride | undefined) => void;
};

export function EnvironmentSelect({ name, value, options, onChange }: Props) {
    return (
        <div className={css.group} role="radiogroup" aria-label={name}>
            {options.map(option => {
                const isActive = (value ?? undefined) === option.value;

                return (
                    <button
                        key={option.label}
                        type="button"
                        role="radio"
                        aria-checked={isActive}
                        className={`${css.option} ${isActive ? css.active : ''}`}
                        onClick={() => onChange(name, option.value)}
                    >
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
}
